import React from "react";
import { useTranslation } from "react-i18next";

function TeacherBenifits() {
    const { t } = useTranslation();

    return (
        <section className='teacherBenefits'>

            <div className='inner-wrapper'>
                <div className='teacher-title animate-from-bottom'>
                    <h2>{t("Instructor Benefits")}</h2>
                </div>

                <div className='tiles-wrapper'>
                    <div className='tile-col'>
                        <div className='col-icon-holder'></div>
                        <div className='col-title'>{t("teacherBenefits.You Teach, We Screen")}</div>
                        <div className='col-desc'>
                            {t("teacherBenefits.benefits1")}
                        </div>
                    </div>

                    <div className='tile-col'>
                        <div className='col-icon-holder'></div>
                        <div className='col-title'>{t("teacherBenefits.Teach for Free")}</div>
                        <div className='col-desc'>
                            {t("teacherBenefits.benefits2")}
                        </div>
                    </div>

                    <div className='tile-col'>
                        <div className='col-icon-holder'></div>
                        <div className='col-title'>
                            {t("teacherBenefits.Go Multilingual")}<span className='new'>New</span>
                        </div>
                        <div className='col-desc'>
                            {t("teacherBenefits.benefits3")}
                        </div>
                    </div>

                    <div className='tile-col'>
                        <div className='col-icon-holder'></div>
                        <div className='col-title'>{t("teacherBenefits.Intellectual Property")}</div>
                        <div className='col-desc'>
                            {t("teacherBenefits.benefits4")}
                        </div>
                    </div>

                    <div className='tile-col'>
                        <div className='col-icon-holder'></div>
                        <div className='col-title'>
                            {t("teacherBenefits.Barrier Free")}<span className='new'>New</span>
                        </div>
                        <div className='col-desc'>
                            {t("teacherBenefits.benefits5")}
                        </div>
                    </div>

                    <div className='tile-col'>
                        <div className='col-icon-holder'></div>
                        <div className='col-title'>{t("teacherBenefits.No Start-Up Costs")}</div>
                        <div className='col-desc'>
                            {t("teacherBenefits.benefits6")}
                        </div>
                    </div>

                    <div className='tile-col'>
                        <div className='col-icon-holder'></div>
                        <div className='col-title'>
                            {t("teacherBenefits.Reputation Builders")}<span className='new'>New</span>
                        </div>
                        <div className='col-desc'>
                            {t("teacherBenefits.benefits7")}
                        </div>
                    </div>

                    <div className='tile-col'>
                        <div className='col-icon-holder'></div>
                        <div className='col-title'>{t("teacherBenefits.No Payment Thresholds")}</div>
                        <div className='col-desc'>
                            {t("teacherBenefits.benefits8")}
                        </div>
                    </div>

                    <div className='tile-col'>
                        <div className='col-icon-holder'></div>
                        <div className='col-title'>{t("teacherBenefits.Choose Your Currency")}</div>
                        <div className='col-desc'>
                            {t("teacherBenefits.benefits9")}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TeacherBenifits;
